import TypographyItemContainer from "../../../ui/layout/page/typography-container/typography-item-container";
import CountableStep from "../../../ui/widgets/countable-step";
import { RequiredAttachmentList } from "../../../ui/widgets/required-attachment-list";
import { RequiredDocumentItem } from "../required-document-item";
import { useMessageSource } from "react-message-source";
import Typography from "../../../ui/widgets/typography";
import {
  CompanyAttachment as CompanyAttachmentDocument,
  PersonAttachment as PersonAttachmentDocument,
} from "../../../api/commercial/generated-types";
import PostalAddress from "../../../ui/widgets/postal-address";

interface PostDocumentsProps {
  isUploadListNotEmpty: boolean;
  requiredCompanyAttachmentsBAA: CompanyAttachmentDocument[];
  requiredPersonAttachmentsBAA: PersonAttachmentDocument[];
  requiredAttachmentsCA: PersonAttachmentDocument[];
}

const PostDocuments = ({
  isUploadListNotEmpty,
  requiredPersonAttachmentsBAA,
  requiredAttachmentsCA,
  requiredCompanyAttachmentsBAA,
}: PostDocumentsProps) => {
  const { getMessage } = useMessageSource();

  return (
    <div className={isUploadListNotEmpty ? "scd-section-pusher-lg" : ""}>
      <CountableStep number={4}>
        <>
          <TypographyItemContainer>
            <Typography variant="h3">
              {getMessage("PostalAddress.title")}
            </Typography>
          </TypographyItemContainer>
          <RequiredDocumentItem
            content={getMessage(
              "DocumentUpload.post-document-signed-master-account",
            )}
          />
          <RequiredDocumentItem
            content={getMessage(
              "DocumentUpload.post-document-signed-card-application",
            )}
          />

          <RequiredAttachmentList
            requiredPersonBaaAttachments={requiredPersonAttachmentsBAA}
            requiredPersonCaAttachments={requiredAttachmentsCA}
            requiredCompanyAttachments={requiredCompanyAttachmentsBAA}
          />
          <div className="scd-section-pusher-lg">
            <PostalAddress />
          </div>
        </>
      </CountableStep>
    </div>
  );
};

export default PostDocuments;
